import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateInventoryRequest } from '../../../store/slices/boardSlice';
import s from '../Settings/SettingsBlock.module.css';
import sg from '../../../../styles/index.module.css';
import { useTranslation } from 'react-i18next';

export function Unit({ value, inventoryGuid, hasFullAccess }) {
    const { t } = useTranslation();
    const [savedValue, setSavedValue] = useState(value);
    const [editedValue, setEditedValue] = useState(savedValue);

    const dispatch = useDispatch();

    const setValue = (e) => {
        e.preventDefault();
        const val = editedValue.trim();

        setEditedValue(val);
        if (val === savedValue) {
            return;
        }
        setSavedValue(val);
        if (val === '') {
            setEditedValue(t('Unit.emptyValue.text'));
        }
        dispatch(
            updateInventoryRequest({
                body: JSON.stringify({ unit: val || t('Unit.emptyValue.text') }),
                inventoryGuid,
            })
        );
    };

    return (
        <div>
            {hasFullAccess && (
                <input
                    data-id="inventory-unit"
                    type="text"
                    className={sg.input}
                    value={editedValue}
                    maxLength="100"
                    onFocus={(e) => {
                        e.target.select();
                    }}
                    onBlur={setValue}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.currentTarget.blur();
                        }
                    }}
                    onChange={(e) => {
                        setEditedValue(e.target.value);
                    }}
                />
            )}
            {!hasFullAccess && <div className={s.valueText}>{value}</div>}
        </div>
    );
}
